/* eslint-disable import/no-cycle */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */

import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import addNotification from '../../../../../__util__/notifications';
import Accordion, { AccordionToggleHeader, AccordionCollapse } from '../../../../../accordion/Accordion';
import Modal, { ModalBody, ModalHeader, ModalFooter } from '../../../../../modal/Modal';
import Button from '../../../../../primitives/form/button/Button';
import WarningAlert from '../../../../../WarningAlert/WarningAlert';
import { setCopyFieldValue, setCheckedList } from '../../redux/files/actionCreators';
import { setActiveAccordionIndex } from '../../redux/internal/actionCreators';
import { commenceFilesUpload, abortFileUpload, handleError } from '../../utils/aws/aws';
import CopyField from '../CopyField/CopyField';
import ProgressBar from '../ProgressBar/ProgressBar';
import UploadFormField from '../UploadFormField/UploadFormField';

export function FileAccordion(props) {
  const {
    files,
    activeAccordionIndex,
    setActiveAccordionIndex,
    setCopyFieldValue,
    notificationDomRef,
    checkedList,
    setCheckedList,
  } = props;

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [cancelledFiles, setCancelledFiles] = useState([]);
  const [animateModal, setAnimateModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [isLinkClicked, setIsLinkClicked] = useState(false);

  const openModal = (file) => {
    setShowModal(true);
    setAnimateModal(true);
    setCheckedList([]);
    setSelectedFile(file);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setShowModal(false);
    setCheckedList([]);

    setTimeout(() => {
      setAnimateModal(false);
    }, 1000);
  };

  const disableCopyFileBtn = (currentFile) => {
    const getFileList = files.filter((file) => {
      if (file.index !== currentFile.index && file.status === 'Needs Input') {
        return file;
      }

      return null;
    });

    return getFileList.length === 0;
  };

  const copyOnClickHandler = () => {
    const copyFiles = files.filter((file) => {
      if (file.index !== selectedFile.index && checkedList.includes(file.index)) {
        return file;
      }

      return null;
    });

    setCopyFieldValue(selectedFile, copyFiles);
    setShowModal(false);
    setTimeout(() => {
      setAnimateModal(false);
    }, 1000);

    addNotification(
      notificationDomRef.current,
      'Success',
      'Your fields were successfully copied to the selected files.',
      'default',
    );
  };

  const uploadOnClickHandler = (e, fileIndex) => {
    // istanbul ignore next
    e.preventDefault();
    setActiveAccordionIndex(-1);
    setUploadedFiles([...uploadedFiles, fileIndex]);
    // istanbul ignore next
    commenceFilesUpload([fileIndex]);
  };

  const cancelOnClickHandler = (e, file, fileIndex) => {
    // istanbul ignore next
    e.preventDefault();
    setCancelledFiles([...cancelledFiles, fileIndex]);
    // abort and then reset the uploader
    // istanbul ignore next
    abortFileUpload(file, handleError);
  };

  useEffect(() => {
    const processedFiles = files.filter((file) => {
      if (file.status === 'Error' || file.status === 'Success') {
        return file;
      }

      return null;
    });

    const uploadingFiles = files.filter((file) => {
      if (file.status === 'Uploading') {
        return file;
      }

      return null;
    });

    const infofieldValues = files.filter((file) => {
      const valuesInInforfield =
        file.values !== undefined
          ? file.values.filter((input) => {
              if (input.value !== '') return input;

              return null;
            })
          : [];

      if (valuesInInforfield.length > 0) {
        return valuesInInforfield;
      }

      return null;
    });

    if (processedFiles.length === files.length) {
      setUploadInProgress(false);
    } else {
      setUploadInProgress(infofieldValues.length > 0 || uploadingFiles.length > 0);
    }
  }, [files]);

  const conditionalIcon = (cancelledFiles, file, fileIndex, isDisable) => {
    if (cancelledFiles.includes(fileIndex) || file.status === 'Error') {
      return 'fa-times';
    }
    if ((isDisable && activeAccordionIndex !== fileIndex) || activeAccordionIndex === fileIndex) {
      return '';
    }
    return 'fa-pencil';
  };

  const getIconText = (file, fileIndex) => {
    if (file.status === 'Success') {
      return 'Upload complete';
    }
    if (cancelledFiles.includes(fileIndex) || file.status === 'Error') {
      return 'Upload failed';
    }
    return '';
  };

  return (
    <>
      {files.map((file, fileIndex) => {
        return (
          <div
            key={fileIndex}
            className={clsx('uploader__container', {
              'uploader__container--dark-border uploader__container--dark-text uploader__container--allow-overflow':
                activeAccordionIndex === fileIndex,
              'uploader__container--light-border': activeAccordionIndex !== fileIndex,
              'uploader__container--dark-text': activeAccordionIndex !== fileIndex && uploadedFiles.includes(fileIndex),
              'uploader__container--light-text':
                activeAccordionIndex !== fileIndex && !uploadedFiles.includes(fileIndex),
            })}
          >
            <Accordion
              disable={uploadedFiles.includes(fileIndex)}
              activeAccordionIndex={activeAccordionIndex}
              title={file.originalFileData.path}
              accordionIndex={fileIndex}
              helperText={`${fileIndex + 1} of ${files.length}`}
              icon={{
                isSVG: false,
                icon: `${
                  file.status === 'Success'
                    ? 'fa-check'
                    : conditionalIcon(cancelledFiles, file, fileIndex, uploadedFiles.includes(fileIndex))
                }`,
              }}
              iconText={getIconText(file, fileIndex)}
              customFunction={() => !uploadedFiles.includes(fileIndex) && setActiveAccordionIndex(fileIndex)}
            >
              <AccordionToggleHeader>
                {uploadedFiles.includes(fileIndex) ? (
                  <div className="uploader__progress-bar">
                    <ProgressBar
                      className="progress-bar"
                      progress={
                        cancelledFiles.includes(fileIndex) || file.status === 'Error' ? 100 : file.uploadProgress
                      }
                      colour={cancelledFiles.includes(fileIndex) || file.status === 'Error' ? '#DE4F4F' : '#5ADE4F'}
                    />
                  </div>
                ) : (
                  <>
                    <hr />
                    Please complete required fields
                  </>
                )}
                {file.status === 'Error' && (
                  <div className="uploader__file-error">
                    <span>
                      Error: {file.error.message}, with Error Code: {file.error.code}
                    </span>
                  </div>
                )}
                {
                  // istanbul ignore next
                  file.status === 'Uploading' && file.abortUpload === false && (
                    <div className="cta__group">
                      <Button
                        name="Cancel Upload"
                        actionType="button"
                        disable={false}
                        buttonType="secondary"
                        handleClick={(e) => {
                          cancelOnClickHandler(e, file, fileIndex);
                        }}
                      />
                      <Button
                        name="Copy fields"
                        actionType="button"
                        disable={disableCopyFileBtn(file)}
                        buttonType="light"
                        handleClick={() => {
                          openModal(file);
                        }}
                      />
                    </div>
                  )
                }
              </AccordionToggleHeader>
              <AccordionCollapse>
                <form className="form" autoComplete="off" noValidate>
                  {file.values &&
                    file.values.map((value, fieldIndex) => (
                      <UploadFormField
                        key={fieldIndex}
                        field={value.field}
                        value={value.value}
                        fileIndex={fileIndex}
                        fieldIndex={fieldIndex}
                        fileStatus={file.status}
                      />
                    ))}
                  <hr />
                  <div className="cta__group cta__group--form">
                    {file.status === 'Needs Input' && (
                      <Button
                        name="Start Upload"
                        actionType="submit"
                        disable={!file.readyToUpload}
                        buttonType="primary"
                        formNoValidate
                        handleClick={(e) => {
                          uploadOnClickHandler(e, fileIndex);
                        }}
                      />
                    )}
                    <Button
                      name="Copy fields"
                      actionType="button"
                      disable={disableCopyFileBtn(file)}
                      buttonType="light"
                      handleClick={() => {
                        openModal(file);
                      }}
                    />
                  </div>
                </form>
              </AccordionCollapse>
            </Accordion>
          </div>
        );
      })}
      <Modal animateModal={animateModal} showModal={showModal}>
        <ModalHeader>
          <div className="copy-field">
            <h1 className="modal__small-title">Copy Fields</h1>
            <h1 className="modal__large-title">Select where fields should copy to:</h1>
          </div>
        </ModalHeader>
        <ModalBody scroll>
          <CopyField files={files} selectedFile={selectedFile} closeModal={closeModal} />
        </ModalBody>
        <ModalFooter>
          <div className="form">
            <div className="cta__group cta__group--form">
              <Button
                name="COPY TO FILE(S)"
                actionType="button"
                disable={checkedList.length === 0}
                buttonType="primary"
                handleClick={() => {
                  copyOnClickHandler();
                }}
              />
              <Button
                name="CANCEL"
                actionType="button"
                disable={false}
                buttonType="light"
                handleClick={(e) => {
                  closeModal(e);
                }}
              />
            </div>
          </div>
        </ModalFooter>
      </Modal>
      {!isLinkClicked && uploadInProgress && (
        <WarningAlert
          isLinkClicked={isLinkClicked}
          setIsLinkClicked={setIsLinkClicked}
          displayModal={false}
          title="Leave this page"
          alertMessage="You currently have active uploads, leaving before they complete will result in data loss."
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    files: state.files.files,
    activeAccordionIndex: state.internal.activeAccordionIndex,
    notificationDomRef: state.internal.notificationDomRef,
    checkedList: state.files.checkedList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCopyFieldValue: (copyFrom, copyTo) => {
      dispatch(setCopyFieldValue(copyFrom, copyTo));
    },
    setActiveAccordionIndex: (value) => {
      dispatch(setActiveAccordionIndex(value));
    },
    setCheckedList: (checkedValue) => {
      dispatch(setCheckedList(checkedValue));
    },
  };
};

FileAccordion.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  activeAccordionIndex: PropTypes.number.isRequired,
  setActiveAccordionIndex: PropTypes.func.isRequired,
  setCopyFieldValue: PropTypes.func.isRequired,
  notificationDomRef: PropTypes.shape().isRequired,
  checkedList: PropTypes.arrayOf(PropTypes.number).isRequired,
  setCheckedList: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FileAccordion);
